export const addTestId = (locator: string) => ({
  'data-testid': locator.replace(/.*data-testid="([^"]+)".*/, '$1'),
});
